import styled from "styled-components";

export const Content = styled.div`
  border-bottom: #416d51 3px solid;
  display: flex;
  width: 100%;
  justify-content: center;
  background-color: #02291a;
  /* background-color: rgb(0, 153, 51); */
  @media (max-width: 1024px) {
    display: none;
  }
`;

export const Container = styled.div`
  /* max-width: 1170px; */
  width: 100%;
  /* max-width: 1300px; */
  height: 41px;
  position: fixed;
  background-color: #02291a;
  z-index: 2000;
  

  display: flex;

  justify-content: space-between;
  /* padding:0 30px; */
`;

export const SubContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: auto;

  .linksInformations {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    text-decoration: none;
    align-items: center;
    /* padding: 0 10px; */

    .facebook {
      color: white;
      :hover {
        color: #19c455;
      }
    }

    .instagram {
      color: white;
      :hover {
        color: #19c455;
      }
    }

    .youtube {
      color: white;
      :hover {
        color: #19c455;
      }
    }

    :hover {
      p {
        color: #19c455;
        transition: 200ms ease-in-out;
      }
    }

    p {
      color: white;
      font-weight: 650;
      font-size: 12px;
      padding: 0 5px;
    }
  }

  a {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    text-decoration: none;
    align-items: center;
    padding: 0 10px;

    .facebook {
      color: white;
      :hover {
        color: #19c455;
      }
    }

    .instagram {
      color: white;
      :hover {
        color: #19c455;
      }
    }

    .youtube {
      color: white;
      :hover {
        color: #19c455;
      }
    }

    :hover {
      p {
        color: #19c455;
        transition: 200ms ease-in-out;
      }
    }

    p {
      color: white;
      font-weight: 650;
      font-size: 12px;
      padding: 0 5px;
    }
  }
`;
